module.exports = __webpack_public_path__ + "img/responsive hospitium-01.07f8b3c1.jpg";